module.exports = __webpack_public_path__ + "static/media/italian.e67a4006.jpg";